/**
 * Presence wording — the heartbeat's per-ticket viewer list turned into
 * the one line the row chip and the composer banner show.
 *
 * "Replying" beats "viewing": if anyone has a draft open, that is the
 * fact the other operator needs, so the sentence names only the writers.
 */

const ANONYMOUS = 'A colleague'

/** @returns {null | { names: string[], composing: boolean, label: string }} */
export function presenceSummary(viewers) {
  if (!viewers || viewers.length === 0) return null
  const writers = viewers.filter(v => v.composing)
  const composing = writers.length > 0
  const names = (composing ? writers : viewers).map(v => v.name || ANONYMOUS)
  const verb = names.length === 1 ? 'is' : 'are'
  const action = composing ? 'replying to' : 'viewing'
  return { names, composing, label: `${joinNames(names)} ${verb} ${action} this ticket` }
}

export function initialsOf(name) {
  const letters = (name || '').split(' ').filter(Boolean).map(word => word[0]).join('')
  return letters.toUpperCase().slice(0, 2) || '?'
}

function joinNames(names) {
  if (names.length <= 1) return names[0]
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`
}
